import { Reveal } from "../components/motion";
import { CountUp } from "../components/CountUp";
import { config } from "../config/siteConfig";

const ProofStrip = () => (
  <section
    data-testid="social-proof-strip"
    className="bg-[#08162B] border-y border-white/10"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10 sm:py-12">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {config.stats.map((stat, i) => (
          <Reveal key={stat.label} delay={i * 0.08}>
            <div data-testid={`stat-${stat.label.toLowerCase().replace(/\s+/g, "-")}`}>
              <p className="font-display text-4xl sm:text-5xl text-[#D4AF37]">
                <CountUp value={stat.value ?? "—"} delay={i * 0.08} />
              </p>
              <p className="mt-2 font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.22em] text-white/50">
                {stat.label}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default ProofStrip;
